// extracted by mini-css-extract-plugin
export default {"Auth":"UserAccount_Auth__dDJFG"};